import { IndexModel } from "../Support/IndexModel";
import { axios } from "../Support/Axios";
export class ReportScheduleIndex extends IndexModel {
    endpoint = 'report/schedule';
    getData() {
        return super.getData();
    }
    deleteSchedule(uuid) {
        let self = this;
        const url = this.prefix + 'report/schedule/' + uuid;
        return axios.delete(url).then(function () {
            self.data = false;
            self.page = 1;
            self.load();
        }).catch(e => this.setError(e));
    }
}
